import { render, staticRenderFns } from "./orderProgress.vue?vue&type=template&id=8f0a527a&scoped=true"
import script from "./orderProgress.vue?vue&type=script&lang=js"
export * from "./orderProgress.vue?vue&type=script&lang=js"
import style0 from "./orderProgress.vue?vue&type=style&index=0&id=8f0a527a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0a527a",
  null
  
)

export default component.exports